var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDB001",
    d: "M21.5,-33.7C35,-29.5,57.9,-38.1,60.4,-34.6C63,-31.1,45,-15.6,35,-5.8C25,4,22.8,7.9,24.8,19.2C26.7,30.5,32.9,49,29.5,50.3C26,51.5,13,35.4,0.6,34.3C-11.7,33.1,-23.4,47,-27.1,45.9C-30.8,44.8,-26.4,28.8,-29,18.6C-31.5,8.5,-40.9,4.3,-49.2,-4.8C-57.5,-13.9,-64.7,-27.7,-59.7,-33.4C-54.6,-39.2,-37.2,-36.7,-25.2,-41.9C-13.2,-47,-6.6,-59.6,-1.3,-57.3C4,-55.1,8,-38,21.5,-33.7Z",
    transform: "translate(100 100)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob3);
export default __webpack_public_path__ + "static/media/blob3.c348085e5e44a0228bccf2fe0bec6111.svg";
export { ForwardRef as ReactComponent };